/* generated by pull.js */
const manifest = {
  "editorOnly": true,
  "name": "Hide stage and sprite pane",
  "description": "Adds a button next to the \"small stage\" and \"large stage\" buttons that hides the stage and the sprite pane, making the code area much larger.",
  "credits": [
    {
      "name": "Maximouse",
      "link": "https://scratch.mit.edu/users/Maximouse/"
    }
  ],
  "dynamicDisable": true,
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "userstyles": [
    {
      "url": "style.css"
    }
  ],
  "tags": [],
  "enabledByDefault": true
};
export default manifest;
